import { Trans, useTranslation } from "next-i18next"

import { setReactI18nextExports } from "@bounce/i18n"

export const fixI18nextImports = () => {
  setReactI18nextExports({ useTranslation, Trans })
}
